import { Component, OnInit } from '@angular/core';
import {InsightApiService} from '../../../shared/insights/service/insight-api.service';
import {ReportService} from '../../service/report.service';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { error } from 'console';



@Component({
  selector: 'app-request-files',
  templateUrl: './request-files.component.html',
  styleUrls: ['./request-files.component.scss']
})
export class RequestFilesComponent implements OnInit {
  public shareList:any = null;
  public uuid = this.router.snapshot.params.uuid;

  // public sharingEmails = ['xyz@gmail.com','crownIt@gmail.in','gaurav@gmail.com'];
  // public suggestedEmails = '';
  // public showSuggestion:boolean = false;
  // public isRequestFileOpen:boolean = false;
  

  constructor(
    public Rservice:ReportService,
    public router: ActivatedRoute,
    public insightApi:InsightApiService,
    public notify:NotifierService,



  ) { }

  ngOnInit(): void {
  }

  closeRequestFilePanel(){
    this.Rservice.isRequestFile = false;
    this.Rservice.sharingEmails = [];
    this.Rservice.inviteEmailMessage = "";
  }
  SubmitRequestEmail = () =>
  {
    this.Rservice.submitRequestEmail(this.uuid);
    // if(this.Rservice.sharingEmails.length == 0)
    // {
    //   this.notify.notify('error','Please Select at Least One Email')
    // }
    // else if(!this.Rservice.inviteEmailMessage)
    // {
    //   this.notify.notify('error','Please Fill Message Field')
    // }
    // else
    // {
    //   let body = {};
    //   body['uuid'] = this.uuid;
    //   body['message'] = this.Rservice.inviteEmailMessage;
    //   body['emails'] = this.Rservice.sharingEmails;
    //   this.insightApi.inviteMultipleEmail(body).subscribe((result)=>
    //   {
    //     if(result['status'] == 1)
    //     {
    //       this.notify.notify('success','Request Sent to All Emails SuccessFully');
    //     }
    //     else
    //     {
    //       this.notify.notify('error',result['message']);
    //     }
    //   },error =>
    //   {
    //     this.notify.notify('error','Something Went Wrong')
    //   });
    //   this.Rservice.isRequestFile = false;
    //   this.Rservice.sharingEmails = [];
    // }

  }
  MessageInputField = (Msg:string) =>
  {
    this.Rservice.inviteEmailMessage = Msg;
  }

  deleteSelects(email){
    let index = this.Rservice.sharingEmails.indexOf(email);
    this.Rservice.sharingEmails.splice(index,1);
  }

  // validateCurrentEmail(e){
  //   // console.log("validation on change",this.validateEmail(e.target.value));
  //   // console.log("Initial sharing string",e.target.value);
  //   let trimmedStr = this.removeExtraSpaces(e.target.value);
  //   // console.log("After Trimmed value",trimmedStr);
  //   if(this.validateEmail(trimmedStr)){
  //     console.log(trimmedStr,'HHHHHHHH');
  //     // this.showSuggestion = true;
      
  //   } 
  //   else{
  //     // this.showSuggestion = false;
  //   }
  // }

  saveCurrentEmail(e){
    let trimmedStr = this.removeExtraSpaces(e.target.value);
    if(this.validateEmail(trimmedStr))
    {
      let fd = this.Rservice.sharingEmails.find((va) => va === trimmedStr);
      if(!fd)
      {
        this.Rservice.sharingEmails.push(trimmedStr);
      }
      e.target.value = "";
    }  
  }

  removeExtraSpaces(str){
    return str.replace(/^[ ]+|[ ]+$/g,'');
  }

  validateEmail =(eml)=> /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(eml);


}
